import React from 'react'
import MaterialSymbol from '../material-symbol'

const Error = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="error" {...props} />
))

Error.displayName = 'Error'

export default Error
